import { useState, useEffect } from 'react';
import throttle from 'lodash.throttle';

const DEFAULT_OPTIONS = {
  config: { attributes: true, childList: true, subtree: true },
  throttleTime: 100,
};

function useMutationObservable(targetEl, cb, options = DEFAULT_OPTIONS) {
  const [observer, setObserver] = useState(null);

  useEffect(() => {
    const { throttleTime } = options;

    const obs = new MutationObserver(
      throttleTime > 0 ? throttle(cb, throttleTime) : cb,
    );
    setObserver(obs);
  }, [cb, options, setObserver]);

  useEffect(() => {
    if (!observer) return;
    if (!targetEl) return;
    const { config } = options;
    observer.observe(targetEl, config);
    return () => {
      if (observer) {
        observer.disconnect();
      }
    };
  }, [observer, targetEl, options]);
}

export default useMutationObservable;
